import { AvChartDatum } from '../../../Shared/Interfaces/av-chart-datum.interface';
import { MONITORING_KINDS, MONITORING_STATUS_BUCKETS } from '../Consts/monitoring-chart.const';
import { MonitoringStatusBuckets } from '../Interfaces/monitoring-report.interface';
import { MonitoringKind } from '../Types/monitoring-kind.type';
import { MonitoringStatusBucket } from '../Types/monitoring-status-bucket.type';

export function toKindBars(counts: Record<MonitoringKind, number>): AvChartDatum[] {
  return MONITORING_KINDS.map(({ kind, labelKey, tone }) => ({
    labelKey,
    tone,
    value: counts[kind],
  }));
}

export function toStatusSegments(
  buckets: MonitoringStatusBuckets,
  hidden: ReadonlySet<MonitoringStatusBucket> = new Set(),
): AvChartDatum[] {
  return MONITORING_STATUS_BUCKETS.map(({ bucket, labelKey, tone }) => ({
    labelKey,
    tone,
    value: hidden.has(bucket) ? 0 : buckets[bucket],
  }));
}

export function sumStatusBuckets(
  buckets: MonitoringStatusBuckets,
  hidden: ReadonlySet<MonitoringStatusBucket> = new Set(),
): number {
  return MONITORING_STATUS_BUCKETS.reduce(
    (sum, { bucket }) => sum + (hidden.has(bucket) ? 0 : buckets[bucket]),
    0,
  );
}
